import { render, staticRenderFns } from "./rightsModal.vue?vue&type=template&id=ff995390&scoped=true&lang=pug&"
import script from "./rightsModal.vue?vue&type=script&lang=js&"
export * from "./rightsModal.vue?vue&type=script&lang=js&"
import style0 from "./rightsModal.vue?vue&type=style&index=0&id=ff995390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff995390",
  null
  
)

export default component.exports